import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout
import Layout from "@/components/Layout";

// Pages
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Udicon from "@/pages/Udicon";
import Documenti730 from "@/pages/Documenti730";
import DocumentiIsee from "@/pages/DocumentiIsee";
import Prenota from "@/pages/Prenota";
import News from "@/pages/News";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="chi-siamo" element={<ChiSiamo />} />
            <Route path="servizi" element={<Servizi />} />
            <Route path="udicon" element={<Udicon />} />
            <Route path="documenti-730" element={<Documenti730 />} />
            <Route path="documenti-isee" element={<DocumentiIsee />} />
            <Route path="prenota" element={<Prenota />} />
            <Route path="news" element={<News />} />
            <Route path="contatti" element={<Contatti />} />
            <Route path="privacy" element={<Privacy />} />
          </Route>
          {/* Admin Routes - No Layout */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
